<template>
    <div class="waba-supsis-partner-client-certification-status-update">
        <div class="title">{{ $t("auto.whatsappBusinessApiV2PartnerClientCertificationStatusUpdated") }}</div>
        <div class="meta">
            <div><b>{{ $t("auto.event") }}</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>{{ $t("auto.channelId") }}</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>{{ $t("auto.clientBusinessId") }}</b>: {{ $_.get(activity, "payload.partner_client_certification_info.client_business_id") }}</div>
            <div><b>{{ $t("auto.status") }}</b>: <span :class="statusClass">{{ $_.get(activity, "payload.partner_client_certification_info.status") }}</span></div>
            <div v-if="rejectionReasons.length > 0 && rejectionReasons[0] !== 'NONE'">
                <b>{{ $t("auto.rejectionReasons") }}</b>: {{ rejectionReasons.join(", ") }}
            </div>
        </div>
        <details class="raw">
            <summary>{{ $t("auto.rawPayload") }}</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisPartnerClientCertificationStatusUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
        rejectionReasons() {
            return this.$_.get(this.activity, "payload.partner_client_certification_info.rejection_reasons", []);
        },
        statusClass() {
            const status = this.$_.get(this.activity, "payload.partner_client_certification_info.status");
            if (status === "APPROVED") return "text-success";
            if (status === "REJECTED") return "text-danger";
            return "";
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-partner-client-certification-status-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .text-success {
        color: #28a745;
        font-weight: 600;
    }
    .text-danger {
        color: #dc3545;
        font-weight: 600;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
